import { Directive } from '@angular/core';

@Directive({
  selector: '[uniPrefix]',
})
export class UniPrefixDirective {}
